import React, { createContext, useContext, useState, useCallback } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error", // success | error | warning | info
    variant: "filled", // filled | outlined
  });

  // Function to show Snackbar with message, severity & variant
  const showSnackbar = useCallback((message, { severity = "success", variant = "filled" }) => {
    // Ensure severity is one of the valid values
    const validSeverities = ["success", "error", "warning", "info"];
    const validSeverity = validSeverities.includes(severity) ? severity : "success";
    
    // Ensure variant is either 'filled' or 'outlined'
    const validVariants = ["filled", "outlined"];
    const validVariant = validVariants.includes(variant) ? variant : "filled";

    setSnackbar({
      open: true,
      message,
      severity: validSeverity,
      variant: validVariant,
    });
  }, []);

  // Function to close Snackbar
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top", // Position vertically at the top
          horizontal: "center", // Position horizontally at the center
        }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbar.severity}
          variant={snackbar.variant}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

// Custom Hook for using Snackbar
export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
